export default ($axios) => ({
    patchUserPersonalData(id, data) {
        return $axios({
            method: 'PATCH',
            url: `/users/user/${id}/`,
            data: data
        })
    },
    patchUserJuridicalCompany(id, data) {
        return $axios({
            method: 'PATCH',
            url: `/users/user-group/${id}/create-company/`,
            data: data
        })
    },
})